import { render, staticRenderFns } from "./New-Ai-Request.vue?vue&type=template&id=2ab97f7e&scoped=true&"
import script from "./New-Ai-Request.vue?vue&type=script&lang=js&"
export * from "./New-Ai-Request.vue?vue&type=script&lang=js&"
import style0 from "./New-Ai-Request.vue?vue&type=style&index=0&id=2ab97f7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab97f7e",
  null
  
)

export default component.exports